import { createContext, useContext, type ReactNode } from "react"
import type { BrandConfig } from "./brand-config"

const BrandConfigContext = createContext<BrandConfig | null>(null)

export function BrandConfigProvider({
  config,
  children,
}: {
  config: BrandConfig
  children: ReactNode
}) {
  return <BrandConfigContext value={config}>{children}</BrandConfigContext>
}

export function useBrandConfig(): BrandConfig {
  const config = useContext(BrandConfigContext)
  if (!config) {
    throw new Error("useBrandConfig must be used within a BrandConfigProvider")
  }
  return config
}
